import { splitWords, observeSplitReveal } from '../../assets/js/utils/splitWords'

export default class ImgAccordeon {
  constructor(el) {
    this.el = el
    this.items = [...el.querySelectorAll('.img-accordeon--content')]
    this.medias = [...el.querySelectorAll('.img-accordeon--media')]
    this.dynamicImg = el.dataset.dynamicImg === 'true'
    this.img = null
    this.init()
  }

  init() {
    this.wrapMedias()
    this.img = this.el.querySelector('.img-accordeon--medias')
    this.items.forEach((item, i) => {
      item.querySelector('.img-accordeon--content-heading').addEventListener('click', () => this.toggle(i))
    })
    if (this.items.length) this.open(0)
    if (this.dynamicImg) this.medias[0]?.classList.add('is-active')

    const subtitle = this.el.querySelector('.img-accordeon--subtitle')
    const title = this.el.querySelector('.img-accordeon--title')

    let offset = 0
    if (subtitle) {
      splitWords(subtitle, offset)
      offset += subtitle.querySelectorAll('.tt-word').length
    }
    if (title) splitWords(title, offset)

    observeSplitReveal(this.el)

    if (this.img) {
      this.ticking = false
      window.addEventListener('scroll', () => this.onScroll(), { passive: true })
      this.parallax()
    }
  }

  onScroll() {
    if (this.ticking) return
    this.ticking = true
    requestAnimationFrame(() => {
      this.parallax()
      this.ticking = false
    })
  }

  parallax() {
    const rect = this.el.getBoundingClientRect()
    if (rect.bottom < 0 || rect.top > window.innerHeight) return
    // Parallax atténué sur mobile (rendu plus stable)
    const factor = window.innerWidth <= 768 ? 0.25 : 1
    this.img.style.transform = `translateY(${-rect.top * 0.08 * factor}px)`
  }

  wrapMedias() {
    if (!this.medias.length) return
    const wrapper = document.createElement('div')
    wrapper.className = 'img-accordeon--medias'
    this.medias[0].parentNode.insertBefore(wrapper, this.medias[0])
    this.medias.forEach(m => wrapper.appendChild(m))
  }

  toggle(i) {
    this.items[i].classList.contains('is-open') ? this.close(i) : this.activate(i)
  }

  activate(i) {
    this.items.forEach((_, j) => this.close(j))
    this.open(i)
  }

  open(i) {
    this.items[i].classList.add('is-open')
    if (!this.dynamicImg) this.medias[i]?.classList.add('is-active')
  }

  close(i) {
    this.items[i].classList.remove('is-open')
    if (!this.dynamicImg) this.medias[i]?.classList.remove('is-active')
  }
}
